module.exports = __webpack_public_path__ + "img/2019_badge.6c41bf65.png";